import React, { FormEvent } from 'react';
import { DraggableData } from 'react-draggable';
import { getBounds } from './index';
import { ROWS_COUNT } from '../components/DraggableNote/DraggableNote';

interface IBounds {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export const NOTE_TYPE = 'note';
export const LABEL_TYPE = 'label';
export const PARENT_ELEMENT = 'parentElement';
export const OFFSET_PARENT = 'offsetParent';

export const dragStart = (
  data: DraggableData,
  parent: string,
  setBounds: React.Dispatch<React.SetStateAction<IBounds>>
): void => {
  if (data) {
    const { node } = data;
    node.style.zIndex = '40';
    const element = parent === PARENT_ELEMENT ? node.parentElement : node.offsetParent;
    setBounds(getBounds(node, element as HTMLElement));
  }
};

export const OnContentChange = (
  event: FormEvent<HTMLTextAreaElement | HTMLInputElement>,
  setContent: (value: React.SetStateAction<string>) => void,
  type: string
): boolean => {
  const target = event.target as HTMLTextAreaElement;
  const length = target.value.length;
  const rows = target.value.substr(0, target.selectionStart).split(/\r?\n|\r/).length + 2;

  switch (type) {
    case NOTE_TYPE:
      if ((length <= 200 && rows <= ROWS_COUNT) || length === 0) {
        setContent(target.value);
        return true;
      }
      break;
    case LABEL_TYPE:
      if ((length <= 20 && target.value.match(/^[A-Za-z-!?. ]+$/)) || length === 0) {
        setContent(target.value);
        return true;
      }
      break;
    default:
      return false;
  }

  return false;
};
